import React  from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useState } from "react";
import swal from "sweetalert";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import { useNavigate } from "react-router-dom";

export default function Signup() {
  const navigate = useNavigate();
   const API_URL = "/api";
 const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    password: "",
    confirmPassword: "",
    companyName: "",
    gst: "",
    address: "",
    reference: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  setErrors((prev) => ({
    ...prev,
    [name]: "",
  }));
};



const validate = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Enter valid 10 digit mobile number";
    }

    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter valid email";
    }

    if (formData.password.length < 6) {
      newErrors.password = "Minimum 6 characters required";
    }

    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    return newErrors;
  };
  // Handle Submit
 const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);

    try {
      const payload = {
    name: formData.name,
    mobile: formData.mobile,
    email: formData.email,
    password: formData.password,
    companyName: formData.companyName,
    gst: formData.gst,
    address: formData.address,
    reference: formData.reference,
};
      const response = await fetch(`${API_URL}/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

if (response.ok && data.message === "User created successfully.") {
  await swal("Success!", "Signup successful!", "success");

  // Reset form
  setFormData({
    name: "",
    mobile: "",
    email: "",
    password: "",
    confirmPassword: "",
    companyName: "",
    gst: "",
    address: "",
    reference: "",
  });

  setErrors({});
  navigate("/login");
} 
else if (data.message === "Email or mobile number already exists.") {
  swal("Warning!", data.message, "warning");
} 
else {
  swal("Error!", data.message || "Something went wrong!", "error");
}

    } catch (error) {
      console.error(error);
     
      swal("Error!", "Something went wrong!", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <Header /> */}
      <IndiaBoatsTopBar />
      <PremiumNavbar />
     <section className="user-signup-section-container">
      <div className="signup-card">
        <h2 className="signup-title">Create Your Account</h2>
        <p className="signup-subtitle">
          Join us to access exclusive offers and manage your bookings.
        </p>

        <form className="signup-form" onSubmit={handleSubmit} noValidate>
          <div className="form-group-grid">

            {/* Name */}
            <div className="input-group">
              <label className="input-label">Your Name</label>
              <input
  type="text"
  name="name"
  placeholder="Enter your name"
  className="signup-input"
  value={formData.name}
  onChange={handleChange}
/>

              {errors.name && <p className="error">{errors.name}</p>}
            </div>

            {/* Mobile */}
            <div className="input-group">
              <label className="input-label">Mobile Number</label>
              <input
  type="tel"
  name="mobile"
  placeholder="Enter mobile number"
  className="signup-input"
  value={formData.mobile}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 10);

    setFormData((prev) => ({ ...prev, mobile: value }));

    setErrors((prev) => ({
      ...prev,
      mobile: "",
    }));
  }}
/>


              {errors.mobile && <p className="error">{errors.mobile}</p>}
            </div>

            {/* Email */}
            <div className="input-group full-width">
              <label className="input-label">Email Address</label>
              <input
  type="email"
  name="email"
  placeholder="Enter email address"
  className="signup-input"
  value={formData.email}
  onChange={handleChange}
/>

              {errors.email && <p className="error">{errors.email}</p>}
            </div>

            {/* Password */}
            <div className="input-group">
              <label className="input-label">Password</label>
             <input
  type="password"
  name="password"
  placeholder="Enter password"
  className="signup-input"
  value={formData.password}
  onChange={handleChange}
/>

              {errors.password && <p className="error">{errors.password}</p>}
            </div>

            {/* Confirm Password */}
            <div className="input-group">
              <label className="input-label">Confirm Password</label>
              <input
  type="password"
  name="confirmPassword"
  placeholder="Confirm password"
  className="signup-input"
  value={formData.confirmPassword}
  onChange={handleChange}
/>

              {errors.confirmPassword && (
                <p className="error">{errors.confirmPassword}</p>
              )}
            </div>
          </div>

          {/* Optional Fields */}
          <div className="form-group-grid">
            <div className="input-group">
              <label className="input-label">Company Name (optional)</label>
              <input
  type="text"
  name="companyName"
  placeholder="Enter company name"
  value={formData.companyName}
  onChange={handleChange}
/>
            </div>

            <div className="input-group">
              <label className="input-label">GST Number (optional)</label>
            <input
  type="text"
  name="gst"
  placeholder="Enter GST number"
  value={formData.gst}
  onChange={handleChange}
/>
            </div>

            <div className="input-group full-width">
              <label className="input-label">Company Address (optional)</label>
              
<input
  type="text"
  name="address"
  placeholder="Enter address"
  value={formData.address}
  onChange={handleChange}
/>
            </div>

            <div className="input-group full-width">
              <label className="input-label">Reference (optional)</label>
              <input
  type="text"
  name="reference"
  placeholder="Enter reference"
  value={formData.reference}
  onChange={handleChange}
/>
            </div>
          </div>

          {/* Submit */}
          <button
            type="submit"
            className="signup-submit-btn"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Sign Up"}
          </button>
        </form>

        <div className="signup-footer">
          <p>
            Already have an account?{" "}
            <a href="/login" className="login-link">
              Login
            </a>
          </p>
        </div>
      </div>

      {/* Simple CSS for errors */}
      <style>
        {`
          .error {
            color: red;
            font-size: 12px;
            margin-top: 4px;
          }
        `}
      </style>
    </section>

      <Footer />
    </>
  );
}
